import { CustomerImportProgressSchema } from "@redotech/redo-model/customer-import";
import * as z from "zod";

export const listCustomerImports = {
  name: "listCustomerImports" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ imports: z.array(CustomerImportProgressSchema) }),
};
